import { i18n } from "@/setup/i18n-setup";

export abstract class Activity {
	en:string = ""
	nl:string = "";
	fr:string = ""
	de:string = "";

	public constructor(data:any){
		this.en = data.en;
		this.nl = data.nl;
		this.fr = data.fr;
		this.de = data.de;
	}

	public getTranslation(){
		let lang = i18n.locale;
		if (lang == "nl-be"){
			return this.nl;
		}
		return (this as any)[lang.toLowerCase()] || this.nl;
	}
}